import { closureQuestionService } from "../services";

// state
const state = {
  items: [],
  item: {},
  loading: true
};

// ACTIONS
const actions = {

  // get all closure questions
  GET_LIST({ commit }, options) {
    commit("requestSent");
    options = options || {}
    return new Promise((resolve, reject) => {
      closureQuestionService.getList(options).then(
        cqs => {
          commit("fetchItemsSuccess", cqs);
          resolve(cqs);
        },
        error => {
          commit("requestFail");
          reject(error);
        }
      );
    });
  },
};

// MUTATIONS
const mutations = {

  // http request fails
  requestFail(state) {
    state.loading = false;
    state.item = {};
    state.items = [];
  },
  // http request sent
  requestSent(state) {
    state.loading = true;
  },

  // colection
  fetchItemsSuccess(state, items) {
    state.loading = false;
    state.items = items;
  }
};

// GETTERS
const getters = {
  isLoading: state => state.loading
};

// EXPORT
export const closureQuestion = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
